import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMusic = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 15V4.16667L17.5 2.5V13.3333M7.5 15C7.5 16.3807 6.38071 17.5 5 17.5C3.61929 17.5 2.5 16.3807 2.5 15C2.5 13.6193 3.61929 12.5 5 12.5C6.38071 12.5 7.5 13.6193 7.5 15ZM17.5 13.3333C17.5 14.714 16.3807 15.8333 15 15.8333C13.6193 15.8333 12.5 14.714 12.5 13.3333C12.5 11.9526 13.6193 10.8333 15 10.8333C16.3807 10.8333 17.5 11.9526 17.5 13.3333Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMusic;
